import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { AmbassadorCard } from '@yme/components/Destinations/Ambassadors/AmbassadorCard';
import { getAmbassadorDetailsPageState } from '@yme/components/Destinations/Ambassadors/AmbassadorDetailsPage/redux/selectors';
import { IndentWrapper } from '@yme/components/Separator';
import { getBloomreachModel, getGlobalSearchItemId, getIsInAuthor } from '@yme/selectors/common';
import { PixelPageView, setPixelPageView } from '@yme/utils/bloomreach';
export function AmbassadorDetailsCard({ isRemoveBottomIndent }) {
    const data = useSelector(getAmbassadorDetailsPageState);
    const globalSearchItemId = useSelector(getGlobalSearchItemId);
    const { productCatalog, contentCatalog } = useSelector(getBloomreachModel);
    const isInAuthor = useSelector(getIsInAuthor);
    useEffect(() => {
        if (productCatalog && contentCatalog && globalSearchItemId && !isInAuthor) {
            setPixelPageView(PixelPageView.CONTENT, {
                catalogs: [
                    {
                        name: contentCatalog,
                    },
                ],
                item_id: globalSearchItemId,
                item_name: document.title,
                domain_key: productCatalog,
            });
        }
    }, [contentCatalog, globalSearchItemId, isInAuthor, productCatalog]);
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { pt: "85px", lgPt: "96px" },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(AmbassadorCard, { data: data }))))));
}
AmbassadorDetailsCard.displayName = 'AmbassadorDetailsCard_AEMComponent';
